<template>
    <div>
        <div class="head">
            <el-breadcrumb style="margin-left:20px" separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/processManager'}">全流程安全生产</el-breadcrumb-item>
                <el-breadcrumb-item>变更管理</el-breadcrumb-item>
                <el-breadcrumb-item>变更验收</el-breadcrumb-item>
            </el-breadcrumb>

            
        </div>
        <div class="content">
            <div style="display: flex;width: 100%;justify-content: space-between;">
                <el-button type="primary"  @click="handleAdd()" size="small">新建</el-button>
                <!-- <el-select v-model="modifyType" placeholder="状态" clearable size="small" @change="getData(1)">
                    <el-option v-for="(item, key) in arr" :label="item.label" :value="item.value"></el-option>
                </el-select> -->
                <Input search enter-button placeholder=" 请输入名称" v-model="fileNameOrTag" @on-search="getData(1)" style="width: 300px"/>

            </div>
            <div style="margin-top: 20px;">
                <el-table :data="tableData" style="width: 100%">
                    <el-table-column prop="termNum" label="项目编号"></el-table-column>
                    <el-table-column prop="termName" label="变更项目"></el-table-column>
                    <el-table-column prop="acceptorName" label="验收人"></el-table-column>
                    <el-table-column prop="modifyAcceptingVo.acceptingTime" label="验收日期"></el-table-column>
                    <el-table-column prop="modifyAcceptingVo.acceptorOpinion" label="验收意见"></el-table-column>
                    <el-table-column prop="status" label="状态">
                        <template slot-scope="scope">
                            <el-tag type="success" v-if="scope.row.status == 0">待审批</el-tag>
                            <el-tag type="success" v-if="scope.row.status == 1">部门领导审批完成</el-tag>
                            <el-tag type="success" v-if="scope.row.status == 2">主管部门领导审批完成</el-tag>
                            <el-tag type="success" v-if="scope.row.status == 3">实施人员审批完成</el-tag>
                            <el-tag type="success" v-if="scope.row.status == 4">公司领导审批</el-tag>
                            <el-tag type="success" v-if="scope.row.status == 5">待验收</el-tag>
                            <el-tag type="success" v-if="scope.row.status == 6">已验收</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column prop="oper" label="操作" width="180">
                        <template slot-scope="scope">
                                <div slot="reference" class="name-wrapper">
                                    <el-link type="primary" @click="handChange(scope.row.id,scope.row)">编辑</el-link>
                                    |
                                    <el-link type="info" @click="examine(scope.row)">审核</el-link>
                                    |
                                    <el-link type="danger" @click="handleDel(scope.row)">删除</el-link>
                                </div>
                        </template>
                    </el-table-column>
                </el-table>
                <Page style="float: right;margin-top: 10px" :total="total" :page-size="sizePage" :current="curPage"
                      @on-change="getData" />
            </div>
        </div>

      <!-- 点击审批的抽屉 -->
      <el-drawer :visible.sync="drawer2" direction="rtl" :before-close="handleClose2" size="70%">
            <span slot="title">
                <div style="margin-left: 1%">
                    <span style="font-size: 20px"><b>{{spObj.termNum}}</b></span>
                </div>
                <div style="margin-top: 1%;margin-left: 1%">
                    <el-row :gutter="20">
                        <el-col :span="6">
                            <div class="grid-content bg-purple"><b>变更项目</b></div>
                            <div class="grid-content bg-purple"
                                 style="margin-top: 3%"><span>{{spObj.term_num}}</span></div>
                        </el-col>
                        <el-col :span="6">
                            <div class="grid-content bg-purple"><b>变更类别</b></div>
                            <div class="grid-content bg-purple" style="margin-top: 3%">
                                <span v-if="spObj.modify_type === 0">变更工艺</span>
                                <span v-if="spObj.modify_type === 1">机械设备变更</span>
                                <span v-if="spObj.modify_type === 2">管理变更</span>
                                <span v-if="spObj.modify_type === 3">其它</span>
                            </div>
                        </el-col>
                        <el-col :span="6">
                            <div class="grid-content bg-purple"><b>申请日期</b></div>
                            <div class="grid-content bg-purple" style="margin-top: 3%">
                                <span>{{spObj.gmtCreate}}</span>
                            </div>
                        </el-col>
                    </el-row>
                </div>
            </span>
            <div style="background-color: #e9eef3;height: 95%;margin-top: 1%">
                <el-tabs v-model="activeName" style="margin-left: 2%">
                    <el-tab-pane label="审批详情" name="a" >
                        <div style="width: 99%;background:white;padding:30px 0">
                          <el-steps :active="spObj.status" align-center style="width: 100%">
                            <el-step title="主管部门意见">
                              <template slot="description">
                                <div v-if="spObj.status > 0">
                                  <div>{{ spObj.accSupervisorApproveTime }}</div>
                                  <div>{{ spObj.acc_supervisor_name }}</div>
                                  <div>{{ spObj.accSupervisorOpinion }}</div>
                                </div>
                              </template>
                            </el-step>
                            <el-step title="沟通部门意见">
                              <template slot="description">
                                <div v-if="spObj.status > 1">
                                  <div>{{ spObj.accExecutorApproveTime }}</div>
                                  <div>{{ spObj.acc_executor_name }}</div>
                                  <div>{{ spObj.accExecutorOpinion }}</div>
                                </div>
                              </template>
                            </el-step>
                            <el-step title="部门领导意见">
                              <template slot="description">
                                <div v-if="spObj.status > 2">
                                  <div>{{ spObj.accLeaderApproveTime }}</div>
                                  <div>{{ spObj.acc_leader_dep_name }}</div>
                                  <div>{{ spObj.accLeaderDepOpinion }}</div>
                                </div>
                              </template>
                            </el-step>
                            <el-step title="公司领导意见">
                              <template slot="description">
                                <div v-if="spObj.status > 3">
                                  <div>{{ spObj.accCompanyApproveTime }}</div>
                                  <div>{{ spObj.acc_company_name }}</div>
                                  <div>{{ spObj.accCompanyOpinion }}</div>
                                </div>
                              </template>
                            </el-step>
                          </el-steps>
                          <el-divider content-position='center'></el-divider>
                          <div v-if='(spObj.status == 0 && userId == spObj.accDepSupervisorId) || (spObj.status == 1 && userId == spObj.accDepLeaderId)
                           || (spObj.status == 2 && userId == spObj.accDepLeaderId) || (spObj.status == 3 && userId == spObj.accCompanyLeaderId)'>
                            <div style="width: 95%;padding-left: 100px">
                              <el-input
                                type="textarea"
                                :rows="2"
                                placeholder="请输入内容"
                                v-model="textarea">
                              </el-input>
                            </div>
                            <div style="text-align:center;margin-top: 15px">
                              <el-button size="small" @click="back" v-if="spObj.status > 0">回退</el-button>
                              <el-button size="small" @click="submitSp">提交</el-button>
                            </div>
                          </div>
                        </div>
                    </el-tab-pane>
                </el-tabs>
            </div>
        </el-drawer>

    </div>
</template>

<script>
import { proAcceptexamineDetail, proAcceptexamine, proAcceptBackScroll } from "@/api/processManager"
    export default {
        data() {
            return {
                total: 0,
                sizePage: 10,
                curPage: 1,
                tableData: [],
                fileNameOrTag:'',
                arr:[],
                modifyType:'',
                drawer2: false, // 审批的抽屉状态
                spObj: {}, // 审批的数据
                dealId: '',
                activeName: 'a',
                userId: '',
                textarea: ''
            };
        },
        created() {
            this.userId = localStorage.getItem('userId')
            this.getData(1);
        },
        methods: {
            getData(page) {
              this.curPage = page
                this.componentsMoudel.httpRequest
                    .getRequestHander(this.componentsMoudel.getData("urls").getmodifyAccepting+"?limit="
                        +this.sizePage +"&curPage="+page+"&searchParam="+this.fileNameOrTag)
                    .openLoad()
                    .startGet()
                    .then((res) => {
                        this.tableData = res.body.data;
                        // this.curPage = res.body.page;
                        this.total = res.body.cum;
                        this.pageTotal = res.body.pageTotal;
                    });
            },
            handleSizeChange(val) {
                this.sizePage = val;
            },
            handleCurrentChange(val) {
                this.curtPage = val;
            },
            handleAdd() {
                this.$router.push({
                    path: "addProAcc",
                });
            },
            handChange(id, row) {
                this.$router.push({
                    name: "addProAcc",
                    params: {key: row},
                });
            },
            handleDel(id) {
                this.componentsMoudel.httpRequest
                    .getRequestHander("/modifyAccepting/delete/"+id.modifyAcceptingVo.id)
                    .openLoad()
                    .startPost()
                    .then((res) => {
                      if(this.tableData.length <= 1 && this.curPage > 1) {
                        this.curPage -= 1
                      }
                        this.$message({
                            showClose: true,
                            message: "删除成功",
                            type: "success",
                        });
                        this.getData(this.curPage);
                    });

            },

            // 审核按钮
            examine(row) {
              // console.log(id)
              this.drawer2 = true
              this.dealId = row.modifyAcceptingVo.id
              this.getSpDetail(row.modifyAcceptingVo.id)
            },
            // 获取审批详情的函数
            getSpDetail(id) {
              proAcceptexamineDetail(id).then(res => {
                // console.log(res)
                this.spObj = {...res.body.data}
              })
            },
            // 抽屉关闭
            handleClose2() {
                this.drawer2 = false;
            },
            // 提交审核
            submitSp() {
              if(this.textarea === "") {
                this.$message.error('请输入审核意见')
                return
              }
              proAcceptexamine({modifyAcceptingId: this.spObj.id, modifyAudit:this.textarea}).then(res => {
                this.$message.success('提交成功')
                this.getSpDetail(this.dealId)
                this.textarea = ''
              })
            },
          // 回滚审核
          back() {
            proAcceptBackScroll({modifyAcceptingId: this.spObj.id}).then(res => {
              this.$message.success('回退成功')
              this.getSpDetail(this.dealId)
              this.textarea = ''
            })
          }
        },
    };
</script>

<style scoped>
    .myHead {
        position: absolute;
        top: 0px;
        left: 250px;
        width: 80%;
        height: 60px;
    }

    .addBtn {
        width: 100px;
        position: absolute;
        top: 10px;
        right: 10px;
    }
</style>
